import { useUpdate } from 'react-admin';
import { useGetAppConfig } from './useGetAppConfig';
import { useOnSettled } from './useOnSettled';
import { useCallback } from 'react';
import { Box, CircularProgress, Switch } from '@mui/material';
import { Semaphore } from './Semaphore';
import { useLogEffect } from '@/util/useLogEffect';

export const MandatoryOTAForm = () => {
  const [updateConfig, { isLoading: isUpdating }] = useUpdate(
    'therapistAppConfig',
    { id: 'current' },
  );

  const {
    remoteAppConfig: { otaUpdatesMandatory },
    refetchAppConfig,
  } = useGetAppConfig();

  const { onSettled: doSettled } = useOnSettled();

  const onSettled = useCallback(async () => {
    doSettled();

    await refetchAppConfig();
  }, [doSettled, refetchAppConfig]);

  useLogEffect('otaUpdatesMandatory', otaUpdatesMandatory);

  const onSwitch = useCallback(async () => {
    await updateConfig(
      'therapistAppConfig',
      {
        id: 'current',
        data: { otaUpdatesMandatory: !otaUpdatesMandatory },
      },
      {
        onSettled,
      },
    );
  }, [updateConfig, onSettled, otaUpdatesMandatory]);

  return (
    <Box marginTop="2rem">
      <h2>Mandatory OTA Updates</h2>
      <Box display="flex" flexDirection="row" alignItems="center">
        <Switch checked={otaUpdatesMandatory} onChange={onSwitch} />
        <Box
          marginLeft="1rem"
          display="flex"
          flexDirection="row"
          alignItems="center"
        >
          {isUpdating && <CircularProgress size={14} />}
          {!isUpdating && <Semaphore enabled={otaUpdatesMandatory} />}
        </Box>
      </Box>
    </Box>
  );
};
